<script setup>
import { computed } from 'vue';
import { useMessageFormatter } from 'shared/composables/useMessageFormatter';

const props = defineProps({
  config: {
    type: Object,
    default: () => ({}),
  },
});

const { formatMessageWithLineBreaks } = useMessageFormatter();

const isDefaultScreen = computed(() => {
  return (
    props.config.isDefaultScreen &&
    ((props.config.welcomeHeading &&
      props.config.welcomeHeading.length !== 0) ||
      (props.config.welcomeTagLine && props.config.welcomeTagline.length !== 0))
  );
});

const usesHeaderBackground = computed(() => {
  return (
    props.config.isDefaultScreen &&
    props.config.headerDisplayType === 'background'
  );
});

const headerStyle = computed(() => {
  if (!props.config.isDefaultScreen) return {};

  return {
    color: props.config.headerTextColor || '#FFFFFF',
    '--header-text-color': props.config.headerTextColor || '#FFFFFF',
    ...(usesHeaderBackground.value && props.config.headerBackgroundUrl
      ? { backgroundImage: `url("${props.config.headerBackgroundUrl}")` }
      : {}),
  };
});
</script>

<template>
  <div
    class="rounded-t-lg flex-shrink-0 bg-cover bg-center bg-no-repeat transition-[max-height] duration-300"
    :style="headerStyle"
    :class="
      isDefaultScreen
        ? 'min-h-[175px] w-full bg-n-slate-2 px-4 py-5 dark:bg-n-solid-1'
        : 'bg-n-slate-2 dark:bg-n-solid-1 p-4'
    "
  >
    <div class="relative top-px">
      <div class="flex items-center justify-start">
        <img
          v-if="config.logo && !usesHeaderBackground"
          :src="config.logo"
          class="mr-2 rounded-full logo"
          :class="!isDefaultScreen ? 'h-8 w-8 mb-1' : 'h-12 w-12 mb-2'"
        />
        <div v-if="!isDefaultScreen">
          <div class="flex items-center justify-start gap-1">
            <span class="text-base font-medium leading-3 text-n-slate-12">
              {{ config.websiteName }}
            </span>
            <div
              v-if="config.isOnline"
              class="w-2 h-2 bg-n-teal-10 rounded-full"
            />
          </div>
          <span class="mt-1 text-xs text-n-slate-11">
            {{ config.replyTime }}
          </span>
        </div>
      </div>
      <div v-if="isDefaultScreen" class="overflow-auto max-h-60">
        <h2 class="mb-2 text-2xl break-words">
          {{ config.welcomeHeading }}
        </h2>
        <div
          v-dompurify-html="formatMessageWithLineBreaks(config.welcomeTagline)"
          class="text-sm break-words [&_a]:!text-[var(--header-text-color)] [&_a]:underline"
        />
      </div>
    </div>
  </div>
</template>
